module.exports = __webpack_public_path__ + "media/images/flags/64/Pakistan-f3c8c3e7522a7247759e283621d0dbc4.png";